import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';

function orderedIds(el) {
  return el.sortable('toArray', { attribute: 'data-id' });
}

function getFormattedPositions(column, el) {
  return orderedIds(el).map((id, i) => ({
    id,
    column,
    position: i + 1,
  }));
}

$(() => {
  $('.js-serie-blocks-left, .js-serie-blocks-right').sortable({ connectWith: '.js-serie-blocks' }).on('sortupdate', () => {
    const leftIds = getFormattedPositions('left', $('.js-serie-blocks-left'));
    const rightIds = getFormattedPositions('right', $('.js-serie-blocks-right'));

    $.ajax({
      url: $('.js-serie-blocks-left').data('url'),
      contentType: 'application/json',
      method: 'POST',
      data: JSON.stringify({ serie_blocks: leftIds.concat(rightIds) }),
    });
  });
});
